import React from 'react';
import { Navigate } from 'react-router-dom';

import { MARKETING_PATH, marketingCmsSiteHistoryPath } from '@/views/marketing/marketing-routes';
import { useAuthContext } from 'views/auth/Auth';

import { useCmsPermissions } from './cms-permissions';
import { useCmsMicrosites } from './cms-queries';
import { CmsPageHeader } from './cms-ui';
import { CmsMicrositeList } from './CmsMicrositeList';

export const CmsSitesEntry = () => {
    const permissions = useCmsPermissions();
    const { user } = useAuthContext();
    const ownerUserGUID = permissions.canReview || permissions.canAdmin ? undefined : user?.profileGUID;
    const micrositesQuery = useCmsMicrosites(ownerUserGUID);
    const microsites = micrositesQuery.data ?? [];
    const hasWorkflowPersona = permissions.canReview || permissions.canPublish || permissions.canAdmin;
    const parent = { label: 'Marketing', to: MARKETING_PATH };

    if (permissions.isLoading || micrositesQuery.isLoading) {
        return (
            <>
                <CmsPageHeader title="Advisor Microsites" parent={parent} />
                <div className="text-muted-foreground p-6 text-sm">Loading CMS sites...</div>
            </>
        );
    }

    if (micrositesQuery.isError) {
        return (
            <>
                <CmsPageHeader title="Advisor Microsites" parent={parent} />
                <div className="text-destructive p-6 text-sm">Unable to load CMS sites.</div>
            </>
        );
    }

    if (microsites.length === 1 && !hasWorkflowPersona) {
        return <Navigate to={marketingCmsSiteHistoryPath(microsites[0].cmsMicrositeGUID)} replace />;
    }

    return <CmsMicrositeList microsites={microsites} isLoading={false} isError={false} />;
};
